import { CellTypography } from "../../../pages/conversation_center/components/CellTypography/CellTypography";
import { HeaderSimple } from "../../../pages/conversation_center/components/HeaderSimple/HeaderSimple";
import type { CustomerRowType } from "../../../pages/conversation_center/components/Table/Table.decl";
import type { ColumnType } from "../columns.decl";

export const customerConfig: ColumnType = {
  id: "customer",
  label: <HeaderSimple label="customer" />,
  renderer: (_, value) => {
    if (!value?.length) {
      return null;
    }

    const [
      { fullName, phoneNumber, displayName },
      ...additionalCustomers
    ]: CustomerRowType[] = value;

    const entries = additionalCustomers.map((customer) => ({
      id: customer.phoneNumber,
      text: customer.displayName,
    }));

    const tooltipTitle = fullName ? phoneNumber : undefined;
    return (
      <CellTypography extraEntries={entries} tooltipTitle={tooltipTitle}>
        {displayName}
      </CellTypography>
    );
  },
};
